import { render, staticRenderFns } from "./GlobalSnackbarVuex.vue?vue&type=template&id=340f3331&scoped=true&"
import script from "./GlobalSnackbarVuex.vue?vue&type=script&lang=ts&"
export * from "./GlobalSnackbarVuex.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalSnackbarVuex.vue?vue&type=style&index=0&id=340f3331&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340f3331",
  null
  
)

export default component.exports